import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class BrandService extends Service{
    constructor() {
        super();
        this.baseURL = 'brand';
    }

    findBrandsHasModel() {
        return fetch(SERVER_URL + this.baseURL + "/findBrandsHasModel", {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findBrandsFromModel() {
        return fetch(SERVER_URL + this.baseURL + '/findBrandsFromModel', {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}